<template>
  <div class="page-wrapper">
    <div class="cg-crumb">
      <span class="item">商品管理</span>
      <em class="gap">/</em>
      <span class="item">添加商品</span>
    </div>
    <div class="cg-main-title">添加商品</div>

    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px">
      <div class="cg-mod-title">基础信息</div>
      <div class="cg-form-mod">
        <el-form-item label="所属品牌：" prop="brand">
          <!-- <el-input size="mini" class="w26" v-model.trim="ruleForm.brand" placeholder="请输入商品品牌"></el-input> -->
          <el-select
            size="mini"
            v-model="ruleForm.brand"
            placeholder="请选择所属品牌"
            @change="selectBrand"
          >
            <el-option
              :label="item.item_display_name"
              :value="item.item_display_name"
              v-for="(item, index) in brandList"
              :key="index"
            ></el-option>
          </el-select>
          <span class="brand-tip">
            找不到品牌？去个人设置页
            <em class="add-brand" @click="toBrandPage">添加品牌</em>
          </span>
        </el-form-item>
        <el-form-item label="商品名称：" prop="productName">
          <el-input
            size="mini"
            class="w48"
            maxlength="50"
            v-model="ruleForm.productName"
            placeholder="请输入商品名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品款号：" prop="styleNumber">
          <el-input
            size="mini"
            class="w26"
            maxlength="50"
            v-model="ruleForm.styleNumber"
            placeholder="请输入商品款号"
          ></el-input>
        </el-form-item>
        <el-form-item label="吊牌价：" prop="itemOriginalPrice">
          <el-input
            size="mini"
            class="w26"
            style="width: 160px"
            v-model="ruleForm.itemOriginalPrice"
            placeholder="请输入吊牌价"
          ></el-input>
          <span class="unit">元</span>
        </el-form-item>
        <el-form-item label="销售价格：" prop="sellingPrice">
          <el-input
            size="mini"
            style="width: 160px"
            v-model="ruleForm.sellingPrice"
            placeholder="请输入销售价格"
          ></el-input>
          <span class="unit">元</span>
          <span class="result-text">结算价格：{{settlePrice}} 元</span>
        </el-form-item>
        <el-form-item label prop="rate">
          <div class="tip-text" style="height: 30px;">
            分佣比例为“销售商 : 供应商={{dealerRate}}% :
            <el-input
              size="mini"
              class="w26"
              style="width: 80px"
              v-model="ruleForm.rate"
              placeholder="请输入"
            ></el-input>%”，平台服务费为您分佣后获得收益的{{serviceFeeShow}}，如 单件所收服务费=单价x分佣比例x{{serviceFeeShow}}。
          </div>
        </el-form-item>
        <el-form-item label="商品类目：">
          <el-col :span="5">
            <el-form-item prop="productCategory_cate1">
              <el-select
                size="mini"
                v-model="ruleForm.productCategory_cate1"
                style="width: 94%"
                value-key="category_id"
                placeholder="请选择类目"
                @change="selectCate(1)"
              >
                <el-option
                  :label="item.category_name"
                  :value="item"
                  v-for="item in cateList1"
                  :key="item.category_id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item prop="productCategory_cate2">
              <el-select
                size="mini"
                v-model="ruleForm.productCategory_cate2"
                style="width: 94%"
                value-key="category_id"
                placeholder="请选择类目"
                @change="selectCate(2)"
              >
                <el-option
                  :label="item.category_name"
                  :value="item"
                  v-for="item in cateList2"
                  :key="item.category_id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item prop="productCategory_cate3">
              <el-select
                size="mini"
                v-model="ruleForm.productCategory_cate3"
                style="width: 94%"
                value-key="category_id"
                placeholder="请选择类目"
              >
                <el-option
                  :label="item.category_name"
                  :value="item"
                  v-for="item in cateList3"
                  :key="item.category_id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
      </div>
      <!-- <div class="cg-mod-title">尺码数量</div> -->
      <!-- <div class="cg-form-mod">
            <div class="line-lab">请选择尺码类型</div>
            <div class="size-type-wrap">
              <el-radio-group v-model="ruleForm.sizeType" @change="handleSizeTypeChange">
                <el-radio :label="1">常规尺码</el-radio>
                <el-radio :label="2">裤装尺码</el-radio>
                <el-radio :label="3">童装尺码</el-radio>
              </el-radio-group>
            </div>
            <div class="size-list-wrap">
              <el-checkbox-group v-model="checkedSizes1" @change="handleCheckedSizesChange" v-show="ruleForm.sizeType == 1">
                <el-checkbox class="check-box" v-for="(item, index) in sizeTypeList1" :label="item.dataName" :key="index">{{item.dataName}}</el-checkbox>
              </el-checkbox-group>
              <el-checkbox-group v-model="checkedSizes2" @change="handleCheckedSizesChange" v-show="ruleForm.sizeType == 2">
                <el-checkbox class="check-box" v-for="(item, index) in sizeTypeList2" :label="item.dataName" :key="index">{{item.dataName}}</el-checkbox>
              </el-checkbox-group>
              <el-checkbox-group v-model="checkedSizes3" @change="handleCheckedSizesChange" v-show="ruleForm.sizeType == 3">
                <el-checkbox class="check-box" v-for="(item, index) in sizeTypeList3" :label="item.dataName" :key="index">{{item.dataName}}</el-checkbox>
              </el-checkbox-group>
              <div class="btn-wrap">
                <button class="cg-btn red" type="button" @click="handleSizeSure">确定</button>
              </div>
            </div>
            <transition-group name="fade" tag="div">
              <div class="color-group" v-for="(item, index) in ruleForm.colorList" :key="item.key">
                  <div>
                    <el-form-item label="商品颜色：" required>
                      <el-input size="mini" class="w26" v-model="item.color" placeholder="请输入商品颜色"></el-input>
                      <span class="result-text w">库存小计：{{item.count}}</span>
                      <span class="color-btn btn-expand" v-show="item.expand" @click="handleExpandSize(item)">收起 <i class="el-icon-arrow-up"></i></span>
                      <span class="color-btn btn-expand" v-show="!item.expand" @click="handleExpandSize(item)">展开 <i class="el-icon-arrow-down"></i></span>
                      <span class="color-btn btn-close" @click="HandleCloseColor(item, index)">删除 <i class="el-icon-close"></i></span>
                    </el-form-item>
                    <div class="color-size-number" v-show="item.expand">
                      <div class="line">
                        <div class="lab">尺码</div>
                        <div class="val">库存</div>
                      </div>
                      <div class="line" v-for="(size_item, size_index) in item.sizeArr" :key="size_index">
                        <div class="lab">{{size_item.name}}</div>
                        <div class="val">
                          <el-input-number v-model="size_item.number" size="small" @change="handleSizeNumberChange(item)" :min="0" label="描述文字"></el-input-number>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </transition-group>
            <div class="btn-wrap" v-if="ruleForm.colorList.length > 0">
              <button class="cg-btn red" type="button" @click="hanldeAddColor">新增颜色组</button>
            </div>
      </div>-->
      <div class="cg-mod-title">颜色-尺码-数量</div>
      <div class="cg-form-mod">
        <div class="line-lab req">请添加商品颜色</div>
        <div class="color-list-wrap">
          <div class="item" v-for="(item, index) in colorArr" :key="index">
            <i
              class="el-icon-check color-checked"
              v-if="item.color.length>0"
              @click="colorItemDel(item, index)"
            ></i>
            <i class="color-unchecked" v-else></i>
            <el-input
              size="mini"
              class="w26"
              v-model.trim="item.color"
              placeholder="请输入商品颜色"
              @input="colorItemInput(item, index)"
            ></el-input>
            <div class="error" v-if="item.err">该颜色已存在！</div>
          </div>
        </div>
        <div class="line-lab req">请选择尺码类型</div>
        <div class="size-type-wrap">
          <el-radio-group v-model="ruleForm.sizeType" @change="handleSizeTypeChange">
            <el-radio :label="1">常规尺码</el-radio>
            <el-radio :label="2">裤装尺码</el-radio>
            <el-radio :label="3">童装尺码</el-radio>
          </el-radio-group>
        </div>
        <div class="size-list-wrap">
          <div v-show="ruleForm.sizeType == 1">
            <el-checkbox
              class="check-box"
              v-for="(item, index) in sizeTypeList1"
              :label="item"
              :key="index"
              v-model="item.checked"
              @change="sizeItemChange"
            >{{item.dataName}}</el-checkbox>
          </div>
          <div v-show="ruleForm.sizeType == 2">
            <el-checkbox
              class="check-box"
              v-for="(item, index) in sizeTypeList2"
              :label="item"
              :key="index"
              v-model="item.checked"
              @change="sizeItemChange"
            >{{item.dataName}}</el-checkbox>
          </div>
          <div v-show="ruleForm.sizeType == 3">
            <el-checkbox
              class="check-box"
              v-for="(item, index) in sizeTypeList3"
              :label="item"
              :key="index"
              v-model="item.checked"
              @change="sizeItemChange"
            >{{item.dataName}}</el-checkbox>
          </div>
        </div>
        <div
          class="color-size-wrap"
          v-if="this.ruleForm.colorList.length > 0 && this.ruleForm.colorList[0].sizeArr.length > 0"
        >
          <div class="line-lab">颜色尺码表</div>
          <div class="take-order-table">
            <table class="table">
              <thead>
                <tr class="th">
                  <th width="20%">颜色</th>
                  <th width="20%">尺码</th>
                  <th width="30%">数量</th>
                  <th width>小计</th>
                </tr>
              </thead>
              <tbody v-for="(p_item, p_index) in this.ruleForm.colorList" :key="p_index">
                <tr v-for="(s_item, s_index) in p_item.sizeArr" :key="s_index">
                  <td v-if="s_index == 0" :rowspan="p_item.sizeArr.length">{{p_item.color}}</td>
                  <td>{{s_item.name}}</td>
                  <td>
                    <el-input-number
                      v-model="s_item.number"
                      size="small"
                      :min="0"
                      :precision="0"
                      @focus="focusStock(p_item, s_item)"
                      @blur="blurStock(p_item, s_item)"
                      @change="changeStock(p_item, s_item)"
                    ></el-input-number>
                  </td>
                  <td v-if="s_index == 0" :rowspan="p_item.sizeArr.length">{{p_item.count}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="cg-mod-title">面辅料信息</div>
      <div class="cg-form-mod">
        <el-form-item label="主面料名称：">
          <el-input size="mini" class="w26" v-model="ruleForm.fabricName" placeholder="请输入主面料名称"></el-input>
        </el-form-item>
        <el-form-item label="主面料成分：">
          <el-radio-group v-model="ruleForm.fabricIngredient_type">
            <el-radio :label="1">
              <span style="margin-right: 10px;">自填</span>
              <el-input
                size="mini"
                class="w14"
                v-model="ruleForm.fabricIngredient_custom"
                placeholder="请输入主面料成分"
              ></el-input>
            </el-radio>
            <el-radio :label="2">
              <span style="margin-right: 10px;">选择面料</span>
              <el-select
                size="mini"
                style="margin-right: 16px; width: 140px"
                v-model="ruleForm.fabricIngredient_seclet"
                placeholder="请选择"
              >
                <el-option
                  :label="item.dataName"
                  :value="item.dataName"
                  v-for="(item, index) in fabricList"
                  :key="index"
                ></el-option>
              </el-select>
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="填充物：">
          <el-input
            size="mini"
            class="w26"
            v-model="ruleForm.fabricStuffing"
            placeholder="请输入主面料成分"
          ></el-input>
        </el-form-item>
      </div>
      <div class="cg-mod-title">商品图片</div>
      <div class="cg-form-mod">
        <el-form-item label="商品图片：" prop="imageUrl_1">
          <p class="main-pic-upload-text-tips">建议尺寸比例 1:1，商品主图为必填</p>
          <!-- 图 1 -->
          <div class="main-pic-upload-wrap">
            <div class="item">
              <el-upload
                class="cg-img-drag-uploader"
                :action="uploadFileApi"
                name="files"
                drag
                :data="uploadData"
                :show-file-list="false"
                :on-success="(res, file) => {return handleImgSuccess(res, file, '1')}"
                :before-upload="beforeImgUpload"
                accept="image/*"
              >
                <div class="el-upload__text">
                  将图片拖到此处或
                  <em>点击上传</em>
                </div>
              </el-upload>
            </div>
            <div class="item or">或</div>
            <div class="item">
              <paste-upload
                @on-success="(res, file) => {return pasteUploadSuccess(res, file, '1')}"
              ></paste-upload>
            </div>
            <div class="item mgl-50">
              <div class="cg-img-drag-show" :class="{'del': ruleForm.imageUrl_1}">
                <div class="main-tag">
                  <strong>*</strong> 商品主图
                </div>
                <el-image
                  v-if="ruleForm.imageUrl_1"
                  class="cg-img"
                  :src="ruleForm.imageUrl_1"
                  fit="cover"
                  :preview-src-list="[ruleForm.imageUrl_1]"
                ></el-image>
                <div class="del-btn" v-if="ruleForm.imageUrl_1" @click="delImg('1')">删除</div>
              </div>
            </div>
          </div>

          <!-- 图 2 -->
          <!-- <div class="main-pic-upload-wrap">
                <div class="item">
                    <el-upload
                      class="cg-img-drag-uploader"
                      :action="uploadFileApi"
                      name="files"
                      drag
                      :data="uploadData"
                      :show-file-list="false"
                      :on-success="(res, file) => {return handleImgSuccess(res, file, '2')}"
                      :before-upload="beforeImgUpload"
                      accept="image/*">
                      <div class="el-upload__text">将图片拖到此处或<em>点击上传</em></div>
                    </el-upload>
                </div>
                <div class="item or">或</div>
                <div class="item">
                    <paste-upload @on-success="(res, file) => {return pasteUploadSuccess(res, file, '2')}"></paste-upload>
                </div>
                <div class="item mgl-50">
                  <div class="cg-img-drag-show" :class="{'del': ruleForm.imageUrl_2}">
                    <el-image
                      v-if="ruleForm.imageUrl_2"
                      class="cg-img"
                      :src="ruleForm.imageUrl_2"
                      fit="cover"
                      :preview-src-list="[ruleForm.imageUrl_2]"
                    ></el-image>
                    <div class="del-btn" v-if="ruleForm.imageUrl_2" @click="delImg('2')">
                      删除
                    </div>
                  </div>
                </div>
          </div>-->

          <!-- 图 3 -->
          <!-- <div class="main-pic-upload-wrap">
                <div class="item">
                    <el-upload
                      class="cg-img-drag-uploader"
                      :action="uploadFileApi"
                      name="files"
                      drag
                      :data="uploadData"
                      :show-file-list="false"
                      :on-success="(res, file) => {return handleImgSuccess(res, file, '3')}"
                      :before-upload="beforeImgUpload"
                      accept="image/*">
                      <div class="el-upload__text">将图片拖到此处或<em>点击上传</em></div>
                    </el-upload>
                </div>
                <div class="item or">或</div>
                <div class="item">
                    <paste-upload @on-success="(res, file) => {return pasteUploadSuccess(res, file, '3')}"></paste-upload>
                </div>
                <div class="item mgl-50">
                  <div class="cg-img-drag-show" :class="{'del': ruleForm.imageUrl_3}">
                    <el-image
                      v-if="ruleForm.imageUrl_3"
                      class="cg-img"
                      :src="ruleForm.imageUrl_3"
                      fit="cover"
                      :preview-src-list="[ruleForm.imageUrl_3]"
                    ></el-image>
                    <div class="del-btn" v-if="ruleForm.imageUrl_3" @click="delImg('3')">
                      删除
                    </div>
                  </div>
                </div>
          </div>-->

          <!-- 图 4 -->
          <!-- <div class="main-pic-upload-wrap">
                <div class="item">
                    <el-upload
                      class="cg-img-drag-uploader"
                      :action="uploadFileApi"
                      name="files"
                      drag
                      :data="uploadData"
                      :show-file-list="false"
                      :on-success="(res, file) => {return handleImgSuccess(res, file, '4')}"
                      :before-upload="beforeImgUpload"
                      accept="image/*">
                      <div class="el-upload__text">将图片拖到此处或<em>点击上传</em></div>
                    </el-upload>
                </div>
                <div class="item or">或</div>
                <div class="item">
                    <paste-upload @on-success="(res, file) => {return pasteUploadSuccess(res, file, '4')}"></paste-upload>
                </div>
                <div class="item mgl-50">
                  <div class="cg-img-drag-show" :class="{'del': ruleForm.imageUrl_4}">
                    <el-image
                      v-if="ruleForm.imageUrl_4"
                      class="cg-img"
                      :src="ruleForm.imageUrl_4"
                      fit="cover"
                      :preview-src-list="[ruleForm.imageUrl_4]"
                    ></el-image>
                    <div class="del-btn" v-if="ruleForm.imageUrl_4" @click="delImg('4')">
                      删除
                    </div>
                  </div>
                </div>
          </div>-->

          <!-- 图 5 -->
          <!-- <div class="main-pic-upload-wrap">
                <div class="item">
                    <el-upload
                      class="cg-img-drag-uploader"
                      :action="uploadFileApi"
                      name="files"
                      drag
                      :data="uploadData"
                      :show-file-list="false"
                      :on-success="(res, file) => {return handleImgSuccess(res, file, '5')}"
                      :before-upload="beforeImgUpload"
                      accept="image/*">
                      <div class="el-upload__text">将图片拖到此处或<em>点击上传</em></div>
                    </el-upload>
                </div>
                <div class="item or">或</div>
                <div class="item">
                    <paste-upload @on-success="(res, file) => {return pasteUploadSuccess(res, file, '5')}"></paste-upload>
                </div>
                <div class="item mgl-50">
                  <div class="cg-img-drag-show" :class="{'del': ruleForm.imageUrl_5}">
                    <el-image
                      v-if="ruleForm.imageUrl_5"
                      class="cg-img"
                      :src="ruleForm.imageUrl_5"
                      fit="cover"
                      :preview-src-list="[ruleForm.imageUrl_5]"
                    ></el-image>
                    <div class="del-btn" v-if="ruleForm.imageUrl_5" @click="delImg('5')">
                      删除
                    </div>
                  </div>
                </div>
          </div>-->
        </el-form-item>
      </div>
      <div class="cg-mod-title">商品详情</div>
      <div class="cg-form-mod">
        <editor v-model="ruleForm.editorContent" />
      </div>
    </el-form>
    <!-- <div class="bottom-btns">
      <button class="cg-btn">取消</button>
      <button class="cg-btn red">确认添加商品</button>
    </div>-->
    <div class="bottom-btns-wrap">
      <button class="cg-btn red big" @click="submitForm">确认添加商品</button>
    </div>
  </div>
</template>

<script>
import editor from "../../../components/EditorFullscreen";
import pasteUpload from "../../../components/pasteUpload";
import {
  addProduct,
  brandListByUser,
  checkStyleNumber
} from "../../../api/supplier";
import {
  getDatasource,
  categoryInfo,
  uploadFileApi
} from "../../../api/public";
import { validatePrice } from "../../../utils/validate";
import { settlePrice, accSub, accDiv, cTrim } from "../../../utils/tools";
import { mapState } from "vuex";
import { storageList } from "../../../utils/storage";
import NP from 'number-precision'

export default {
  components: {
    editor,
    pasteUpload
  },
  computed: {
    ...mapState({
      userId: state => state.user.userId,
      globalServiceCharge: state => state.app.globalServiceCharge
    }),
    serviceFeeShow: function () {
      return NP.times(100, this.globalServiceCharge) + '%'
    },
    settlePrice: function() {
      return settlePrice(this.ruleForm.sellingPrice, this.ruleForm.rate);
    },
    dealerRate: function() {
      if (
        !isNaN(Number(this.ruleForm.rate)) &&
        Number(this.ruleForm.rate) >= 0 &&
        Number(this.ruleForm.rate) <= 100
      ) {
        return accSub(100, Number(this.ruleForm.rate));
      }
      return "--";
    }
  },
  inject: ["reload"],
  data() {
    var validatePriceFn = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请填写价格"));
      } else if (!validatePrice(value)) {
        callback(new Error("价格格式不正确"));
      } else {
        callback();
      }
    };
    var validateRate = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请填写比例"));
      } else if (!validatePrice(value)) {
        callback(new Error("比例格式不正确"));
      } else if (value < 0 || value > 100) {
        callback(new Error("比例必须填0-100之间的数，最多两位小数"));
      } else {
        callback();
      }
    };
    var validateProductName = (rule, value, callback) => {
      if (cTrim(value) === "") {
        callback(new Error("请填写商品名称"));
      } else {
        callback();
      }
    };
    // 判断款号是否重复
    var validateStyleNumber = (rule, value, callback) => {
      if (this.ruleForm.brand === '') {
        callback(new Error("请先选择品牌"));
      } else if (cTrim(value) === '') {
        callback(new Error("请输入商品款号"));
      } else {
        checkStyleNumber({
          "styleNumber": this.ruleForm.styleNumber,
          "userId": this.userId,
          "brand": this.ruleForm.brand || ''
        }).then(res => {
          if (res.errorCode == 200) {
            callback();
          } else if (res.errorCode == -10111){
            callback(new Error(res.errorMsg || '该款号已存在'));
          } else {
            callback(new Error(res.errorMsg || '网络故障，校验异常'));
          }
        }).catch(err => {
          console.log(err)
          callback(new Error('网络故障，校验异常'));
        })
      }
    };
    return {
      // 类目
      cateList1: [],
      cateList2: [],
      cateList3: [],

      // 尺码
      sizeTypeList1: [],
      sizeTypeList2: [],
      sizeTypeList3: [],
      checkedSizes1: [],
      checkedSizes2: [],
      checkedSizes3: [],
      finalCheckedSizes: [],

      // 颜色
      colorArr: [
        {
          color: "",
          key: 1
        }
      ],
      finalColorArr: [],
      colorSizeObj: {
        1: [],
        2: [],
        3: []
      },

      // 颜色组
      colorObj: {
        color: "",
        sizeArr: []
      },

      // 面料列表
      fabricList: [],

      // 上传图片api
      uploadFileApi: "",
      uploadData: {
        imageType: 12101,
        imageUserId: ""
      },

      // 品牌列表
      brandList: [],

      ruleForm: {
        brand: "",
        productName: "",
        styleNumber: "",
        itemOriginalPrice: "",
        sellingPrice: "",
        rate: 60,
        productCategory_cate1: "",
        productCategory_cate2: "",
        productCategory_cate3: "",
        sizeType: 1,
        colorList: [],

        imageUrl_1: "", // 主图
        imgItem_1: "", // 主图
        imageUrl_2: "",
        imgItem_2: "",
        imageUrl_3: "",
        imgItem_3: "",
        imageUrl_4: "",
        imgItem_4: "",
        imageUrl_5: "",
        imgItem_5: "",

        editorContent: "",

        fabricName: "",
        fabricIngredient_type: 1, // 1 - 自填  2 - 选择
        fabricIngredient_custom: "",
        fabricIngredient_seclet: "",
        fabricStuffing: ""
      },
      rules: {
        brand: [
          { required: true, message: "请选择所属品牌", trigger: "change" },
        ],
        productName: [
          { required: true, message: "请输入商品名称", trigger: "change" },
          { validator: validateProductName, trigger: "blur" }
        ],
        styleNumber: [
          { required: true, message: "请输入商品款号", trigger: "change" },
          { validator: validateStyleNumber, trigger: "blur" }
        ],
        itemOriginalPrice: [
          { required: true, message: "请输入吊牌价", trigger: "change" },
          { validator: validatePriceFn, trigger: "change" }
        ],
        rate: [
          { required: true, message: "请输入供应商的比例", trigger: "change" },
          { validator: validateRate, trigger: "change" }
        ],
        sellingPrice: [
          { required: true, message: "请输入价格", trigger: "change" },
          { validator: validatePriceFn, trigger: "change" }
        ],
        // productCategory_cate1: [
        //   { required: true, message: "请选择类目", trigger: "change" }
        // ],
        // productCategory_cate2: [
        //   { required: true, message: "请选择类目", trigger: "change" }
        // ],
        // productCategory_cate3: [
        //   { required: true, message: "请选择类目", trigger: "change" }
        // ],
        imageUrl_1: [
          { required: true, message: "请上传商品主图", trigger: "change" }
        ]
      }
    };
  },
  watch: {},
  created() {
    this.uploadFileApi = uploadFileApi;
    this.uploadData.imageUserId = this.userId;
    this.brandListByUser();
    this.categoryInfo(1, 0);
    this.getDatasource();
  },
  methods: {
    // 获取品牌列表
    brandListByUser() {
      brandListByUser({
        userId: this.userId
      })
        .then(res => {
          console.log(res);
          if (res.errorCode == 200) {
            this.brandList = res.data;
            this.getBrand();
          } else {
            // this.$message.error(res.errorMsg || '获取品牌信息失败')
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 选择品牌 - 存入缓存
    selectBrand(item) {
      console.log(item);
      if (item) {
        localStorage.setItem(storageList.last_edit_brand, item);
      }
      this.$refs["ruleForm"].validateField('styleNumber')
    },
    // 获取缓存中的品牌
    getBrand() {
      let brand = localStorage.getItem(storageList.last_edit_brand);
      if (
        brand &&
        this.brandList.some(item => item.item_display_name == brand)
      ) {
        this.ruleForm.brand = brand;
      }
    },
    // 获取类目列表
    categoryInfo(type, id) {
      categoryInfo({ parentId: id }).then(res => {
        if (res.errorCode == 200) {
          if (type == 1) {
            this.cateList1 = res.data;
          }
          if (type == 2) {
            this.cateList2 = res.data;
            this.ruleForm.productCategory_cate2 = "";
            this.ruleForm.productCategory_cate3 = "";
          }
          if (type == 3) {
            this.cateList3 = res.data;
            this.ruleForm.productCategory_cate3 = "";
          }
        }
      });
    },
    // 选择品类
    selectCate(type) {
      if (type == 1) {
        console.log(this.ruleForm.productCategory_cate1);
        this.categoryInfo(2, this.ruleForm.productCategory_cate1.category_id);
      }
      if (type == 2) {
        this.categoryInfo(3, this.ruleForm.productCategory_cate2.category_id);
      }
    },
    // 获取尺码数据
    getDatasource() {
      getDatasource({ types: "10202,10203,10204,10237" }).then(res => {
        console.log(res);
        if (res.errorCode == 200) {
          this.sizeTypeList1 = res.data.regularSize.list.map((item, index) => {
            return {
              ...item,
              key: "regular" + (index + 1),
              checked: false
            };
          });
          console.log(this.sizeTypeList1);
          this.sizeTypeList2 = res.data.pantsSize.list.map((item, index) => {
            return {
              ...item,
              key: "pants" + (index + 1),
              checked: false
            };
          });
          console.log(this.sizeTypeList2);
          this.sizeTypeList3 = res.data.childSize.list.map((item, index) => {
            return {
              ...item,
              key: "child" + (index + 1),
              checked: false
            };
          });
          console.log(this.sizeTypeList3);
          this.fabricList = res.data.mainComponentFabric.list;

          this.createColorSizeTable("color");
        }
      });
    },
    submitForm() {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          if (this.ruleForm.colorList.length == 0) {
            return this.$message.error("请选择尺码并添加颜色值");
          }
          if (this.ruleForm.colorList.some(item => item.color == "")) {
            return this.$message.error("必须填写颜色组的颜色值");
          }
          if (
            !this.ruleForm.colorList[0].sizeArr ||
            this.ruleForm.colorList[0].sizeArr.length == 0
          ) {
            this.$message.error("至少选择一个尺码");
            return;
          }

          // if (this.ruleForm.colorList.some(item => item.count == 0)) {
          //   return this.$message.error('每一颜色组的数量小计必须大于0')
          // }

          let productCategory = ''
          if (this.ruleForm.productCategory_cate1.category_name) {
            productCategory += this.ruleForm.productCategory_cate1.category_name
          }
          if (this.ruleForm.productCategory_cate2.category_name) {
            productCategory += '-' + this.ruleForm.productCategory_cate2.category_name
          }
          if (this.ruleForm.productCategory_cate3.category_name) {
            productCategory += '-' + this.ruleForm.productCategory_cate3.category_name
          }

          let colorSizeQuantity = {};
          colorSizeQuantity["group"] = this.ruleForm.colorList.map(item => {
            return {
              color: item.color,
              sizeArr: item.sizeArr.map(b => {
                return {
                  name: b.name,
                  number: b.number
                };
              })
            };
          });
          let colorSizeQuantityStr = JSON.stringify(colorSizeQuantity);

          let fabricAndAccessory = {};
          fabricAndAccessory["fabricName"] = this.ruleForm.fabricName;
          fabricAndAccessory["fabricStuffing"] = this.ruleForm.fabricStuffing;
          fabricAndAccessory[
            "fabricIngredient_type"
          ] = this.ruleForm.fabricIngredient_type;
          if (this.ruleForm.fabricIngredient_type == 1) {
            fabricAndAccessory[
              "fabricIngredient_custom"
            ] = this.ruleForm.fabricIngredient_custom;
            fabricAndAccessory["fabricIngredient_seclet"] = "";
          } else {
            fabricAndAccessory["fabricIngredient_custom"] = "";
            fabricAndAccessory[
              "fabricIngredient_seclet"
            ] = this.ruleForm.fabricIngredient_seclet;
          }
          let fabricAndAccessoryStr = JSON.stringify(fabricAndAccessory);

          let imgJsonArr = [];
          if (this.ruleForm.imgItem_1) {
            imgJsonArr.push(this.ruleForm.imgItem_1);
          }
          let imgJson = JSON.stringify(imgJsonArr);
          let supplierRate = accDiv(this.ruleForm.rate, 100);
          let dealerRate = accDiv(this.dealerRate, 100);
          let itemFeeSplitting = dealerRate + "," + supplierRate;
          let form = {
            userId: this.userId,
            brand: this.ruleForm.brand,
            productName: cTrim(this.ruleForm.productName),
            styleNumber: cTrim(this.ruleForm.styleNumber),
            sellingPrice: this.ruleForm.sellingPrice,
            itemOriginalPrice: this.ruleForm.itemOriginalPrice,
            itemFeeSplitting: itemFeeSplitting,
            productCategory: productCategory,
            colorSizeQuantityStr: colorSizeQuantityStr,
            fabricAndAccessoryStr: fabricAndAccessoryStr,
            imgJson: imgJson,
            productContent: this.ruleForm.editorContent
          };
          console.log(form);
          addProduct(form)
            .then(res => {
              console.log(res);
              if (res.errorCode == 200) {
                // this.$message.success('添加商品成功')
                this.$confirm("添加商品成功!", "提示", {
                  confirmButtonText: "继续添加",
                  cancelButtonText: "商品列表",
                  type: "success",
                  center: true
                })
                  .then(() => {
                    // 继续添加
                    this.reload();
                    if (document.getElementById("appMain")) {
                      document.getElementById("appMain").scrollTop = 0;
                    }
                  })
                  .catch(() => {
                    this.$router.push("/supplier/goods/list");
                  });
              } else {
                this.$message.error(res.errorMsg || "添加商品失败");
              }
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    // 确定尺码选择
    handleSizeSure() {
      this.finalCheckedSizes = [
        ...this["checkedSizes" + this.ruleForm.sizeType]
      ];
      console.log(this.finalCheckedSizes);
      if (this.finalCheckedSizes.length == 0) {
        this.$message.error("至少选择一个尺码");
        return;
      }
      if (this.ruleForm.colorList.length > 0) {
        this.$confirm("确认后，将重置已新增的颜色组，是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.handleResetColor();
        });
      } else {
        this.handleResetColor();
      }
    },
    handleSizeNumberChange(item) {
      console.log(item);
      let count = 0;
      item.sizeArr.forEach(ele => {
        count += ele.number;
      });
      item.count = count;
      console.log(this.ruleForm.colorList);
    },
    handleResetColor() {
      let colorObj = {
        color: "",
        expand: true,
        count: 0,
        sizeArr: this.finalCheckedSizes.map(item => {
          return {
            name: item,
            number: 0
          };
        })
      };
      this.colorObj = JSON.parse(JSON.stringify(colorObj));
      this.ruleForm.colorList = [];
      this.ruleForm.colorList.push({
        ...colorObj,
        key: new Date().getTime()
      });
    },
    hanldeAddColor() {
      let colorObj = JSON.parse(
        JSON.stringify({
          ...this.colorObj,
          key: new Date().getTime()
        })
      );
      this.ruleForm.colorList.push(colorObj);
    },
    handleExpandSize(item) {
      item.expand = !item.expand;
    },
    HandleCloseColor(item, index) {
      console.log(item, index);
      this.$confirm("确认删除该颜色组吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.ruleForm.colorList.splice(index, 1);
        this.$message({
          type: "success",
          message: "删除成功!"
        });
      });
    },
    // 图片粘贴上传成功
    pasteUploadSuccess(res, file, NUM) {
      console.log(res, file);
      if (res.errorCode == 200) {
        this.ruleForm["imgItem_" + NUM] = res.data;
        this.ruleForm["imageUrl_" + NUM] = URL.createObjectURL(file);
        if (NUM == "1") {
          this.$refs["ruleForm"].clearValidate("imageUrl_1");
        }
      }
    },
    // 图片上传成功
    handleImgSuccess(res, file, NUM) {
      console.log(res, file);
      if (res.errorCode == 200) {
        this.ruleForm["imgItem_" + NUM] = res.data;
        this.ruleForm["imageUrl_" + NUM] = URL.createObjectURL(file.raw);
        if (NUM == "1") {
          this.$refs["ruleForm"].clearValidate("imageUrl_1");
        }
      }
    },
    delImg(NUM) {
      console.log(NUM);
      this.ruleForm["imgItem_" + NUM] = "";
      this.ruleForm["imageUrl_" + NUM] = "";
      if (NUM == "1") {
        this.$refs["ruleForm"].validateField("imageUrl_1");
      }
    },
    beforeImgUpload(file) {
      console.log(file);

      const isImg = /^image\/*/.test(file.type);
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isImg) {
        this.$message.error("请上传图片格式的文件!");
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return isImg && isLt5M;
    },
    // 去个人设置页
    toBrandPage() {
      this.$router.push("/supplier/setting");
    },

    // colorItemAdd() {
    //   let item = {
    //     color: this.colorAddValue,
    //     edit: false,
    //     key: Date.now()
    //   }
    //   this.colorArr.push(item);
    //   this.colorAddValue = ''
    // },
    // colorItemEditSure (item) {
    //   item.edit = false
    //   item.oldColor = ''
    // },
    // colorItemEditCancel (item) {
    //   item.edit = false
    //   item.color = item.oldColor
    //   item.oldColor = ''
    // },
    // colorItemEdit (item) {
    //   item.oldColor = item.color
    //   item.edit = true
    // },
    // colorItemDel (item, index) {
    //   this.colorArr.splice(index, 1)
    // },

    // 输入颜色值
    colorItemInput(item, index) {
      if (index == this.colorArr.length - 1) {
        if (item.color.length > 0) {
          this.colorArr.push({
            color: "",
            key: this.colorArr[this.colorArr.length - 1].key + 1
          });
        }
      }
      this.checkSameColor(item, index);
    },
    // 判断颜色值是否重复
    checkSameColor(item, index) {
      if (
        item.color != "" &&
        this.colorArr.some((ele, i) => i != index && ele.color == item.color)
      ) {
        item.err = true;
      } else {
        this.colorArr.forEach(ele => {
          if (ele.err) ele.err = false;
        });
        console.log(item, "fdsafsafa");
        this.createColorSizeTable("color");
      }
    },
    // 删除颜色
    colorItemDel(item, index) {
      this.colorArr.splice(index, 1);
      this.createColorSizeTable("color", "del", index);
    },

    // 尺码
    handleSizeTypeChange(value) {
      console.log(value);
      this.createColorSizeTable("color");
    },

    sizeItemChange(value) {
      this.createColorSizeTable("size");
    },

    // 生成表格
    createColorSizeTable(type, del, index) {
      if (type == "color") {
        if (del == "del") {
          for (let key in this.colorSizeObj) {
            if (this.colorSizeObj[key].length > 0) {
              this.colorSizeObj[key].splice(index, 1);
            }
          }
        } else {
          if (this.colorSizeObj[this.ruleForm.sizeType].length == 0) {
            this.colorSizeObj[this.ruleForm.sizeType] = this.colorArr.map(
              c_item => {
                return {
                  color: c_item.color,
                  key: c_item.key,
                  count: 0,
                  sizeArr: this["sizeTypeList" + this.ruleForm.sizeType].map(
                    item => {
                      return {
                        name: item.dataName,
                        number: 0,
                        checked: item.checked,
                        key: item.key
                      };
                    }
                  )
                };
              }
            );
          } else {
            this.colorArr.forEach((c_item, c_index) => {
              let curIndex = 0;
              let colorFilter = this.colorSizeObj[
                this.ruleForm.sizeType
              ].filter((c, i) => {
                if (c.key == c_item.key) {
                  curIndex = i;
                  return true;
                }
              });
              if (colorFilter.length == 0) {
                this.colorSizeObj[this.ruleForm.sizeType].push({
                  color: "",
                  key: c_item.key,
                  count: 0,
                  sizeArr: this["sizeTypeList" + this.ruleForm.sizeType].map(
                    item => {
                      return {
                        name: item.dataName,
                        number: 0,
                        checked: item.checked,
                        key: item.key
                      };
                    }
                  )
                });
              } else {
                this.colorSizeObj[this.ruleForm.sizeType][curIndex].color =
                  c_item.color;
              }
            });
          }
        }
      }

      if (type == "size") {
        this.colorSizeObj[this.ruleForm.sizeType].forEach(item => {
          item.sizeArr.forEach((ele, i) => {
            ele.checked = this["sizeTypeList" + this.ruleForm.sizeType][
              i
            ].checked;
          });
        });
      }

      console.log(this.colorSizeObj[this.ruleForm.sizeType]);
      this.ruleForm.colorList = this.colorSizeObj[this.ruleForm.sizeType]
        .filter(item => item.color != "")
        .map(ele => {
          let checkedSizeArr = ele.sizeArr.filter(a => a.checked);
          return {
            ...ele,
            sizeArr: checkedSizeArr,
            count: checkedSizeArr.reduce((total, s) => {
              return total + s.number;
            }, 0)
          };
        });
      console.log(this.ruleForm.colorList);
    },

    // 修改库存
    changeStock(p, s) {
      // if (isNaN(s.number)) s.number = 0
      this.sumStock(p, s);
    },
    focusStock(p, s) {
      console.log(p, s);
      if (s.number == 0) {
        s.number = undefined;
      }
    },
    blurStock(p, s) {
      if (s.number === "" || s.number === undefined) {
        s.number = 0;
      }
      this.sumStock(p, s);
    },
    // 计算小计
    sumStock(p, s) {
      let count = 0;
      p.sizeArr.forEach(element => {
        count += Math.round(element.number) || 0;
      });
      p.count = count;
    }
  }
};
</script>

<style lang="scss" scoped>
.page-wrapper {
  padding: 24px 24px 40px;

  .brand-tip {
    height: 17px;
    font-size: 12px;
    color: #999;
    line-height: 17px;
    margin-left: 24px;
    .add-brand {
      color: #333;
      cursor: pointer;
      font-style: normal;
      &:hover {
        color: #f81d22;
      }
    }
  }

  .size-type-wrap {
    margin-top: 8px;
  }
  .color-list-wrap {
    margin: 10px 0 15px;
    width: 680px;
    box-sizing: border-box;
    .item {
      position: relative;
      margin-bottom: 10px;
      padding-left: 24px;
      .color-checked {
        position: absolute;
        left: 0;
        top: 6px;
        color: #f81d22;
        font-weight: bold;
        font-size: 14px;
        border: 1px solid #f81d22;
        cursor: pointer;
      }
      .error {
        color: #f56c6c;
        font-size: 12px;
        line-height: 1;
        padding-top: 4px;
      }
    }
  }
  .size-list-wrap {
    margin-top: 16px;
    padding: 16px 16px 0;
    width: 680px;
    box-sizing: border-box;
    border: 1px solid #e6e6e6;
    background: rgba(0, 0, 0, 0.02);
    .check-box {
      margin-bottom: 16px;
    }
  }
  .btn-wrap {
    margin-top: 24px;
  }
  .color-group {
    margin-top: 16px;
    .el-form-item {
      margin-bottom: 10px;
    }
  }
  .result-text.w {
    display: inline-block;
    width: 160px;
  }
  .color-btn {
    font-size: 14px;
    color: #333;
    cursor: pointer;
    &.btn-expand {
      margin-left: 128px;
    }
    &.btn-close {
      margin-left: 24px;
    }
  }

  .color-size-number {
    padding: 10px 180px 10px 24px;
    width: 680px;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.02);
    .line {
      height: 50px;
      line-height: 50px;
    }
    .lab {
      float: left;
    }
    .val {
      float: right;
      text-align: center;
      width: 140px;
    }
  }

  .color-size-wrap {
    margin-top: 16px;
  }
  .take-order-table {
    .table {
      border: 1px solid #e6e6e6;
      width: 100%;
      width: 680px;
      border-spacing: 0;
      border-collapse: collapse;
      font-size: 14px;
      tr {
        height: 40px;
      }
      tr.th {
        background: #fafafa;
      }
      tr th {
        color: rgba(0, 0, 0, 0.85);
        font-weight: normal;
      }
      td {
        border: 1px solid #e6e6e6;
        text-align: center;
        color: rgba(0, 0, 0, 0.85);
      }
    }
    &.clearing {
      margin-top: 24px;
    }
    &.clearing tr th {
      border: 1px solid #e6e6e6;
    }
    &.clearing tr th:last-child,
    &.clearing tr td:last-child {
      color: #f81d22;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.bottom-btns {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 180px;
  height: 64px;
  text-align: right;
  background: #fff;
  box-shadow: 0px -3px 6px -4px rgba(0, 0, 0, 0.12),
    0px -6px 16px 0px rgba(0, 0, 0, 0.08);
  line-height: 64px;
  z-index: 10001;
  .cg-btn {
    margin-right: 32px;
  }
}

.bottom-btns-wrap {
  width: 980px;
  padding: 40px 0;
  text-align: center;
}
.main-pic-upload-wrap {
  height: 104px;
  &:last-child {
    margin-bottom: 0;
  }
  .item {
    width: 88px;
    height: 88px;
    float: left;
    &.or {
      width: 60px;
      line-height: 88px;
      text-align: center;
      font-size: 12px;
    }

    &.mgl-50 {
      margin-left: 60px;
    }
  }
}
.main-pic-upload-text-tips {
  font-size: 12px;
  color: #999;
}
</style>